import ENV_VARS from '../utils/envVars';
import currentMembershipDocument from '../graphql/queries/currentMembership';
import cancellationReasonsDocument from '../graphql/queries/cancellationReasons';
import membershipOptionsDocument from '../graphql/queries/membershipOptions';
import validateCouponDocument from '../graphql/queries/validateCoupon';
import cancelMembershipDocument from '../graphql/mutations/cancelMembership';
import reactivateMembershipDocument from '../graphql/mutations/reactivateMembership';
import updatePaymentSourceDocument from '../graphql/mutations/updatePaymentSource';
import deleteAccountDocument from '../graphql/mutations/deleteAccount';
import upgradeMembershipDocument from '../graphql/mutations/upgradeMembership';

import {
  MANAGE_LOGIN_SUCCESS,
  MANAGE_LOGIN_FAILURE,
  MANAGE_FETCH_MEMBERSHIP_SUCCESS,
  MANAGE_FETCH_MEMBERSHIP_FAILURE,
  MANAGE_FETCH_REASONS_SUCCESS,
  MANAGE_FETCH_REASONS_FAILURE,
  MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS,
  MANAGE_FETCH_MEMBERSHIP_OPTIONS_FAILURE,
  MANAGE_CANCEL_MEMBERSHIP_SUCCESS,
  MANAGE_CANCEL_MEMBERSHIP_FAILURE,
  MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS,
  MANAGE_REACTIVATE_MEMBERSHIP_FAILURE,
  MANAGE_UPDATE_BILLING_SUCCESS,
  MANAGE_UPDATE_BILLING_FAILURE,
  MANAGE_DELETE_ACCOUNT_SUCCESS,
  MANAGE_DELETE_ACCOUNT_FAILURE,
  MANAGE_UPGRADE_MEMBERSHIP_SUCCESS,
  MANAGE_UPGRADE_MEMBERSHIP_FAILURE,
  MANAGE_VALIDATE_COUPON_SUCCESS,
  MANAGE_VALIDATE_COUPON_FAILURE,
} from '../actions/subscriptionActions';

export function login(username, password, teamId) {
  const data = { username, password, version: '1.0.0' };
  if (teamId) data.teamId = teamId;
  return {
    type: 'API_CALL',
    config: {
      baseURL: ENV_VARS.BASE_URL,
      url: '/authorize',
      method: 'POST',
      data,
    },
    auth: false,
    spinner: true,
    successAction: MANAGE_LOGIN_SUCCESS,
    failureAction: MANAGE_LOGIN_FAILURE,
  };
}

export function fetchMembership() {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'query',
      document: currentMembershipDocument,
      variables: {},
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_FETCH_MEMBERSHIP_SUCCESS,
    failureAction: MANAGE_FETCH_MEMBERSHIP_FAILURE,
  };
}

export function fetchCancellationReasons() {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'query',
      document: cancellationReasonsDocument,
      variables: {},
    },
    auth: true,
    spinner: false,
    successAction: MANAGE_FETCH_REASONS_SUCCESS,
    failureAction: MANAGE_FETCH_REASONS_FAILURE,
  };
}

export function cancelMembership(membershipId, cancellationReasonId) {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'mutation',
      document: cancelMembershipDocument,
      variables: { membershipId, cancellationReasonId },
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_CANCEL_MEMBERSHIP_SUCCESS,
    failureAction: MANAGE_CANCEL_MEMBERSHIP_FAILURE,
  };
}

export function updateBilling(membershipId, paymentMethodId) {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'mutation',
      document: updatePaymentSourceDocument,
      variables: { membershipId, paymentMethodId },
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_UPDATE_BILLING_SUCCESS,
    failureAction: MANAGE_UPDATE_BILLING_FAILURE,
  };
}

export function deleteAccount() {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'mutation',
      document: deleteAccountDocument,
      variables: {},
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_DELETE_ACCOUNT_SUCCESS,
    failureAction: MANAGE_DELETE_ACCOUNT_FAILURE,
  };
}

export function validateCoupon(enteredCoupon, productId) {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'query',
      document: validateCouponDocument,
      variables: { enteredCoupon, membershipId: productId },
    },
    auth: true,
    spinner: false,
    successAction: MANAGE_VALIDATE_COUPON_SUCCESS,
    failureAction: MANAGE_VALIDATE_COUPON_FAILURE,
  };
}

export function fetchMembershipOptions() {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'query',
      document: membershipOptionsDocument,
      variables: {},
    },
    auth: true,
    spinner: false,
    successAction: MANAGE_FETCH_MEMBERSHIP_OPTIONS_SUCCESS,
    failureAction: MANAGE_FETCH_MEMBERSHIP_OPTIONS_FAILURE,
  };
}

export function upgradeMembership(membershipId, productId, enteredCoupon) {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'mutation',
      document: upgradeMembershipDocument,
      variables: { membershipId, productId, enteredCoupon },
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_UPGRADE_MEMBERSHIP_SUCCESS,
    failureAction: MANAGE_UPGRADE_MEMBERSHIP_FAILURE,
  };
}

export function reactivateMembership(membershipId) {
  return {
    type: 'GQL_CALL',
    config: {
      type: 'mutation',
      document: reactivateMembershipDocument,
      variables: { membershipId },
    },
    auth: true,
    spinner: true,
    successAction: MANAGE_REACTIVATE_MEMBERSHIP_SUCCESS,
    failureAction: MANAGE_REACTIVATE_MEMBERSHIP_FAILURE,
  };
}
